<div class="offline-container">
  <!-- Decorative Background Elements -->
  <div class="glow-sphere pulse"></div>
  
  <div class="horizontal-glass-card">
    <div class="offline-content">
      <div class="illustration-wrapper">
        <div class="icon-circle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="offline-svg">
            <path d="M3.28 2.22a.75.75 0 10-1.06 1.06l18.5 18.5a.75.75 0 101.06-1.06L3.28 2.22zM19.924 7.617a.75.75 0 00-.236-1.034 11.944 11.944 0 00-4.966-1.928.75.75 0 10-.244 1.48 10.447 10.447 0 014.412 1.718.75.75 0 001.034-.236zM15.42 12.112a.75.75 0 00-.203-1.042 6.96 6.96 0 00-2.434-1.002.75.75 0 10-.23 1.482 5.462 5.462 0 011.825.765.75.75 0 001.042-.203zM12 17.25a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM7.382 9.431a.75.75 0 00-1.036-.23 10.472 10.472 0 00-2.27 1.724.75.75 0 101.036 1.085 8.973 8.973 0 011.954-1.483.75.75 0 00.316-1.096zM9.548 13.911a.75.75 0 00-1.045-.19 5.492 5.492 0 00-1.127.868.75.75 0 101.03 1.092 3.992 3.992 0 01.83-.635.75.75 0 00.312-1.135z" />
          </svg>
        </div>
      </div>
      
      <div class="text-group">
        <h1 class="offline-title">Oops! You're Offline</h1>
        <p class="offline-message">It looks like your internet connection is taking a break. Please check your network and try again.</p>
        
        <button class="retry-modern-btn" (click)="retry()">
           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="retry-icon">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
          </svg>
          Try Again
        </button>
      </div>
    </div>
  </div>

</div>
